var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",class:{ mobile: _vm.$mq === 'sm' || _vm.$mq === 'md' },attrs:{"src":_vm.src,"alt":"Cafe Glocksee"}})])}
var staticRenderFns = []

export { render, staticRenderFns }